import React, { useEffect, useState } from "react";
import UserDashborad from "./UserDashboard/UserDashborad";
import DashBoardNavBar from "./DashBoardNavBar/DashBoardNavBar";
import { Outlet } from "react-router-dom";

const UserWebsiteLayout = () => {
  // const[matches,setMatches]=useState(
  //   window.matchMedia("(max-width:550px)").matches
  // );
  // useEffect(()=>{
  //   window.matchMedia("(max-width:550px)").addEventListener("change",(e)=>{
  //     setMatches(e.matches);
  //     window.location.reload();
  //   })
  // },[matches])
  return (
    <div>
      {/* {matches ?(
      <div className="desktopViewNotSupport">
      <div className="text-white">
        <h1 className="px-3 text-center" style={{color:'#000'}}>
          DashBorad is only supported in Desktop View. Please adjust your
          screen resolution
        </h1>
      </div>
    </div>
      ) :( */}
<div className="container-fluid">
 <div className="row">
   <DashBoardNavBar />
   <div className="col-lg-2 col-md-1">
     <UserDashborad />
   </div>
   <div
     className="col-lg-10 col-md-11"
     style={{ backgroundColor: "#8080800d"
       , marginTop:'5rem'
     }}
   >
     <Outlet />
   </div>
 </div>
</div>
      {/* )} */}
     
    </div>
  );
};

export default UserWebsiteLayout;
